
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import AkkhorLayout from "../layout/akkhor";
import { useSelector } from "react-redux";
import AlertErrorForm from "../component/AlertErrorForm";
import Spinner from "../component/Spinner";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { Link, useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import SearchBoxModal from "../component/SearchBoxModal";
import { checkRole } from "../model";
import { Modal } from "react-bootstrap";
import ModalSearchMulti from "../component/ModalSearchMulti";
import ActionForm from "./actionForm";


export default function FormNghiepVu() {
    const { user } = useSelector((state) => state.auth);
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const [modalAddMission, setModalAddMission] = useState(false);
    const [listMission, setListMission] = useState([]);
    const rolesAll = checkRole(user, 'works_mission', 'all');

    const defaultdetail = {
        department_id: id, author_id: user.data.id, title: '', status: 1,
    }
    useEffect(
        function () {
            if (id > 0) {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "parts/" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            if (mounted) {
                                let detail = res.data.data
                                if (detail.list_mission) setListMission(detail.list_mission)
                                setDetail(detail);
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            }
        }, [user, id, refresh]
    );
    const formik = useFormik({
        initialValues: defaultdetail,
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            title: Yup.string().trim().nullable().required('Nhập tên nghiệp vụ').max(150, "Độ dài không quá 150 ký tự")
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            setLoading(true)
            if (values.id > 0) {
                Axios.put(URL_LIST_ALL + 'works_mission/' + id, values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn cập nhật nghiệp vụ thành công',
                            buttons: [{ label: 'OK' }]
                        });
                        setModalAddMission(false)
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            } else {
                // console.log(values);
                Axios.post(URL_LIST_ALL + 'works_mission', values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)

                    if (res.data.status === "success") {
                        resetForm();
                        setModalAddMission(false)
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn thêm mới nghiệp vụ thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        },
    });

    return (
        <AkkhorLayout idrole="works_mission">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/works_mission">Quản lý nghiệp vụ</Link>
                    </li>
                    <li>{id ? 'Sửa nghiệp vụ' : 'Thêm mới nghiệp vụ'}</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>Nghiệp vụ: <strong className="text-info">{detail && detail.title}</strong></h3>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-12"></div>
                        <div className="w-100 d-flex">
                            <h4 className="w-100 text-center mt-2">Danh sách nghiệp vụ</h4>
                            <button className="btn btn-sm btn-success" type="button"
                                onClick={() => setModalAddMission(!modalAddMission)}
                            ><span className="fas fa-plus"></span> Thêm nghiệp vụ</button>
                        </div>

                        {(listMission && listMission.length > 0) ?
                            listMission.map((item, i) => <div className="col-12 col-sm-4 mt-2" key={i}>
                                <div className="w-100 h-100 border p-2 rounded position-relative">
                                    Tên nghiệp vụ: <strong className="text-danger">{item.title}</strong><br />
                                    Người tham gia:<br />
                                    {item.list_user && item.list_user.map((usr, j) => <>
                                        <strong>
                                            - {usr.fullname} <small>({usr.email})</small>
                                        </strong><br />
                                    </>)}
                                    <ActionForm item={item}/>
                                </div>
                            </div>)
                            : <h5>Chưa có dữ liệu</h5>}
                    </div>
                </div>
            </div>
            <Modal show={modalAddMission} className="modal-thread" onHide={() => setModalAddMission(false)} size="md">
                <Modal.Header closeButton>
                    <Modal.Title>Thêm nghiệp vụ</Modal.Title>
                </Modal.Header>
                <Modal.Body className="">
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-12 form-group">
                                <label>Tên nghiệp vụ <span className="text-danger">*</span></label>
                                <input type="text" placeholder="Nhập tên nghiệp vụ" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
                            </div>
                            <div className="col-12 form-group">
                                <label>Người được giao </label>
                                <ModalSearchMulti apiname={"users"} multiple={true} placeholder="Chọn nhân sự" colvalue={'id'} colname={'fullname'}
                                    defaultValue={formik.values['user_id']} name='user_id'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('user_id', e)
                                    }}></ModalSearchMulti>
                            </div>
                            <div className="col-12 form-group mg-t-8">
                                <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">
                                    {loading ? <Spinner /> : <>Lưu lại</>}
                                </button>
                                <button type="reset" onClick={formik.resetForm} className="btn-fill-lg bg-blue-dark btn-hover-yellow">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </AkkhorLayout>
    );
}
